import React from 'react';
import PropTypes from 'prop-types';

import {StickyContainer} from 'react-sticky';
import {MenuWrapperStyled, MenuWrapperStyledLight, WrapperLight, SideRestaurantClosed, Wrapper, MenuContent} from './MenuPage.style';
import Categories from '../../components/Categories/Categories';
import CategoriesNav from './CategoriesNav';
import SideBasket from '../../components/SideBasket/SideBasket';
import ServiceTypeModal from '../../components/ServiceTypeModal/ServiceTypeModal';
import BasketModal from '../../components/Modal/BasketModal';
import InfoModal from '../../components/Modal/InfoModal';
import {DISABLED_MEAL, IOS_PRIVATE_MODE, MEAL_PICTURE} from '../../constants/modalType';
import AppModal from '../../components/Modal/AppModal';
import {defaultStyles} from '../../components/Modal/modal.config';
import DeliveryMinimumModal from '../../components/DeliveryMinimumModal/DeliveryMinimumModal';
import UpSellingModal from '../../components/UpSellingModal/UpSellingModal';
import MenuName from './MenuName';

const MenuPageContent = props => {
  const {
    displayMenu,
    offlineMenu,
    iosPrivateModeModal,
    isMobile,
    showSideRestaurantClosed,
    showSideBasket,
    showDeliveryMinimumModal,
    showUpSellingModal,
    showServiceTypeModal,
    menu,
    basket,
    isSideBasketLoading,
    loadExistingBasketItemFunc,
    removeBasketItemFunc,
    updateBasketItemQuantityFunc,
    updateFulfillmentFunc,
    changeFormValueFunc,
    restaurant,
    checkoutForm,
    orderSource,
    handleShowMealModal,
    addItemStraightToBasket,
    handleCloseDeliveryMinimumModal,
    handleCloseUpSellingModal,
    handleGoToCheckoutPage,
    handleShowDisabledMealModal,
    handleHideDisabledMealModal,
    showDisabledMealModal,
    disabledMealDays,
    serverOffline,
    upsellingItems,
    dataForPictureModal,
    handleOpenPictureModal,
    handleClosePictureModal,
    isTemplateLight,
    tableId,
    clearTableId
  } = props;

  const categoriesNavCard = displayMenu && (
    <CategoriesNav
      categories={displayMenu.categories}
      isMobile={isMobile}
      isTemplateLight={isTemplateLight}
    />
  );

  const categoriesCard = displayMenu && (
    <Categories
      categories={displayMenu.categories}
      meals={displayMenu.meals}
      showMealModal={handleShowMealModal}
      handleShowDisabledMealModal={handleShowDisabledMealModal}
      addItemStraightToBasket={addItemStraightToBasket}
      restaurantModes={restaurant.modes}
      menuName={displayMenu.name}
      menuDescription={displayMenu.description}
      promotions={restaurant.content.promotions}
      appliedPromotions={basket.promotions}
      isOfflineMenu={!!offlineMenu}
      serverOffline={serverOffline}
      isTemplateLight={isTemplateLight}
      handleOpenPictureModal={handleOpenPictureModal}
      restaurantCode={restaurant.code}
    />
  );
  const editingMeals = {};
  if (displayMenu && displayMenu.meals) {
    basket.items.forEach(item => editingMeals[item.mealUuid] = displayMenu.meals[item.mealUuid]);
  }
  const serviceTypeModal = showServiceTypeModal && isMobile && !tableId && (
    <ServiceTypeModal
      openingTimes={restaurant.openingTimes}
      basketUuid={basket.uuid}
      changeFormValue={changeFormValueFunc}
      updateFulfillment={updateFulfillmentFunc}
      restaurantModes={restaurant.modes}
    />
  );

  const deliveryMinimumModal = showDeliveryMinimumModal && (
    <AppModal
      customStyles={defaultStyles}
      callback={handleCloseDeliveryMinimumModal}
    >
      <DeliveryMinimumModal
        minimumAmount={restaurant.deliverySettings.minimumAmount}
        total={basket.price.items}
      />
    </AppModal>
  );

  const upSellingModal = showUpSellingModal && (
    <AppModal
      customStyles={defaultStyles}
      callback={handleCloseUpSellingModal}
    >
      <UpSellingModal
        continueToCheckOutCallback={handleGoToCheckoutPage}
        isSideBasketLoading={isSideBasketLoading}
        menu={menu}
        items={upsellingItems}
        addItemStraightToBasket={addItemStraightToBasket}
        restaurantModes={restaurant.modes}
        showMealModal={handleShowMealModal}
        basket={basket}
      />
    </AppModal>
  );

  const renderPictureModal = !!dataForPictureModal && isTemplateLight && InfoModal({
    type: MEAL_PICTURE,
    data: dataForPictureModal,
    closeModalCallback: handleClosePictureModal
  });

  const renderIosPrivateModeModal = iosPrivateModeModal && InfoModal({type: IOS_PRIVATE_MODE});

  const renderMealDisabledModal = showDisabledMealModal && InfoModal({
    type: DISABLED_MEAL,
    closeModalCallback: handleHideDisabledMealModal,
    data: disabledMealDays
  });

  const sideBasket = showSideBasket && (
    <SideBasket
      isMenuPage
      showServiceTypeRadioButtons
      isLoading={isSideBasketLoading}
      goToCheckoutPageCallback={handleGoToCheckoutPage}
      basketItems={basket.items}
      basketUuid={basket.uuid}
      price={basket.price}
      promotions={basket.promotions}
      fulfillment={basket.fulfillment}
      editingMeals={editingMeals}
      loadExistingBasketItem={loadExistingBasketItemFunc}
      removeBasketItem={removeBasketItemFunc}
      updateBasketItemQuantity={updateBasketItemQuantityFunc}
      updateFulfillment={updateFulfillmentFunc}
      payment={restaurant.payment}
      changeFormValue={changeFormValueFunc}
      openingTimes={restaurant.openingTimes}
      checkoutForm={checkoutForm}
      deliverySettings={restaurant.deliverySettings}
      restaurantModes={restaurant.modes}
      isSticky={!isMobile}
      isTemplateLight={isTemplateLight}
      exceptionalClosingTimes={restaurant.exceptionalClosingTimes}
      tableId={tableId}
      clearTableId={clearTableId}
    />
  );

  const sideRestaurantClosed = showSideRestaurantClosed &&
    (<SideRestaurantClosed />);

  const renderMainContent = isTemplateLight ? (
    <MenuWrapperStyledLight>
      <WrapperLight>
        {displayMenu && MenuName({menuName: displayMenu.name})}
        <MenuContent>
          {categoriesNavCard}
          {categoriesCard}
        </MenuContent>
      </WrapperLight>
      {sideBasket}
      {sideRestaurantClosed}
    </MenuWrapperStyledLight>
  ) : (
    <MenuWrapperStyled>
      {categoriesNavCard}
      {categoriesCard}
      {sideBasket}
      {sideRestaurantClosed}
    </MenuWrapperStyled>
  );
  const stickyContainerContent = (
    <Wrapper>
      <BasketModal
        restaurantModes={restaurant.modes}
        offlineMenu={offlineMenu}
        orderSource={orderSource}
      />
      {renderMainContent}
      {serviceTypeModal}
      {deliveryMinimumModal}
      {upSellingModal}
      {renderIosPrivateModeModal}
      {renderMealDisabledModal}
      {renderPictureModal}
    </Wrapper>
  );

  return isMobile ? stickyContainerContent : <StickyContainer data-rw="menu-page--content">{stickyContainerContent}</StickyContainer>;
};

MenuPageContent.propTypes = {
  menu: PropTypes.object.isRequired,
  displayMenu: PropTypes.object.isRequired,
  offlineMenu: PropTypes.object,
  iosPrivateModeModal: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  showSideRestaurantClosed: PropTypes.bool.isRequired,
  showSideBasket: PropTypes.bool.isRequired,
  showDeliveryMinimumModal: PropTypes.bool.isRequired,
  showServiceTypeModal: PropTypes.bool.isRequired,
  basket: PropTypes.object.isRequired,
  isSideBasketLoading: PropTypes.bool.isRequired,
  loadExistingBasketItemFunc: PropTypes.func.isRequired,
  removeBasketItemFunc: PropTypes.func.isRequired,
  updateBasketItemQuantityFunc: PropTypes.func.isRequired,
  updateFulfillmentFunc: PropTypes.func.isRequired,
  changeFormValueFunc: PropTypes.func.isRequired,
  restaurant: PropTypes.object.isRequired,
  checkoutForm: PropTypes.object,
  orderSource: PropTypes.object,
  handleShowMealModal: PropTypes.func.isRequired,
  addItemStraightToBasket: PropTypes.func.isRequired,
  handleCloseDeliveryMinimumModal: PropTypes.func.isRequired,
  handleGoToCheckoutPage: PropTypes.func.isRequired,
  showDisabledMealModal: PropTypes.bool.isRequired,
  handleShowDisabledMealModal: PropTypes.func,
  handleHideDisabledMealModal: PropTypes.func.isRequired,
  disabledMealDays: PropTypes.string,
  serverOffline: PropTypes.bool.isRequired,
  showUpSellingModal: PropTypes.bool.isRequired,
  handleCloseUpSellingModal: PropTypes.func.isRequired,
  handleOpenPictureModal: PropTypes.func.isRequired,
  handleClosePictureModal: PropTypes.func.isRequired,
  upsellingItems: PropTypes.array,
  dataForPictureModal: PropTypes.object,
  isTemplateLight: PropTypes.bool.isRequired,
  tableId: PropTypes.string,
  clearTableId: PropTypes.func
};

export default MenuPageContent;



// WEBPACK FOOTER //
// ./containers/MenuPage/MenuPageContent.js